<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>Collections</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>New Collection</li>
  </ol>
</nav>
<form [hidden]="loading" [formGroup]="collectionForm" class="w-100" novalidate action="javascript:void(0);">
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">

    <div class="form-row">
      <div class="col-md-12 mb-4">
        <label for="name_ar" translate>Name (Arabic)</label>
        <input [ngClass]="{'is-invalid': submitted && f.name_ar.errors }" type="text" formControlName="name_ar" class="form-control" id="name_ar" placeholder="{{'Name (Arabic)' | translate}}">
        <div *ngIf="submitted && f.name_ar.errors && f.name_ar.errors.required" class="invalid-feedback" translate>Required field</div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-md-12 mb-4">
        <label for="name" translate>Name (English)</label>
        <input [ngClass]="{'is-invalid': submitted && f.name.errors }" type="text" formControlName="name" class="form-control" id="name" placeholder="{{'Name (English)' | translate}}">
        <div *ngIf="submitted && f.name.errors && f.name.errors.required" class="invalid-feedback" translate>Required field</div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-md-12 mb-4">
        <div class="d-flex flex-row">
          <label for="products" translate>Products</label>
          <label><a class="my-auto mx-3 text-primary" style="font-size: 8pt" (click)="addAllProducts()" translate>Add All</a></label>
        </div>
        <input #productsTextArea [ngClass]="{'is-invalid': submitted && f.products.errors }" class="form-control auto-height" formControlName="products" id="products" placeholder="{{'Products' | translate}}">
        <div *ngIf="submitted && f.products.errors && f.products.errors.required" class="invalid-feedback" translate>Required field</div>
      </div>
    </div>

  </div>

  <div class="container bg-white border-secondary shadow border-primary p-3 m-3 d-none">
    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="custom-file-container" data-upload-id="thumbnailCollectionImage">
          <label>{{'Thumbnail Collection Image' | translate}} <span style="font-size: 7pt">(300px X 300px)</span>
            <a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a>
          </label>
          <label for="thumbnailCollectionEditor" class="custom-file-container__custom-file">
            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">
            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>
            <span class="custom-file-container__custom-file__custom-file-control"></span>
          </label>

          <pintura-editor id="thumbnailCollectionEditor" #thumbnailCollectionEditor *ngIf="collectionThumbnailUrl != null" [src]="collectionThumbnailUrl"
                          [options]="collectionThumbnailPinturaOptions" [imageCropAspectRatio]="1"
                          (process)="handleEditorProcess($event)">
          </pintura-editor>
          <div *ngIf="loadingThumbnailPictures" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
          <div [hidden]="loadingThumbnailPictures || collectionThumbnailUrl" class="custom-file-container__image-preview"></div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="custom-file-container" data-upload-id="bannerCollectionImage">
          <label for="bannerCollectionEditor">{{'Banner Collection Image' | translate}} <span style="font-size: 7pt">(1600px X 900px)</span>
            <a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a></label>
          <label class="custom-file-container__custom-file">
            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">
            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>
            <span class="custom-file-container__custom-file__custom-file-control"></span>
          </label>
          <pintura-editor id="bannerCollectionEditor" #bannerCollectionEditor *ngIf="collectionBannerUrl != null" [src]="collectionBannerUrl"
                          [options]="collectionBannerPinturaOptions" [imageCropAspectRatio]="16 / 9"
                          (process)="handleEditorProcess($event)"></pintura-editor>
          <div *ngIf="loadingBannerPictures" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
          <div [hidden]="loadingBannerPictures || collectionBannerUrl != null" class="custom-file-container__image-preview"></div>
        </div>
      </div>

    </div>
  </div>

  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <button class="btn btn-primary" type="submit" *ngIf="!isAccountant" (click)="submitForm()" translate>Submit</button>&nbsp;
    <button class="btn btn-light-danger" type="submit" [routerLink]="['/private','collections']" [queryParams]="{type: subAccountType, govId: subAccountGovId}" translate>Close</button>
  </div>
</form>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
